import axios from 'axios';

const BASE_URL =
  process.env.REACT_APP_BASE_URL || 'http://localhost:8000/api/v1';

/**
 * POST /commission/suggest/
 */
export async function fetchSuggestions({ price, margin, convRate }) {
  try {
    const res = await axios.post(`${BASE_URL}/api/v1/commission/suggest/`, {
      price,
      margin,
      conv_rate: convRate,
    });

    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.errors
        ? JSON.stringify(err.response.data.errors)
        : 'Server error'
    );
  }
}

/**
 * POST /commission/calculate/
 */
export async function fetchCalculation({
  price,
  margin,
  convRate,
  demoOverride,
  salesPctOverride,
  guestOverride,
  noShowOverride,
}) {
  try {
    const res = await axios.post(`${BASE_URL}/api/v1/commission/calculate/`, {
      price,
      margin,
      conv_rate: convRate,
      demo_override: demoOverride ?? null,
      sales_pct_override: salesPctOverride ?? null,
      guest_override: guestOverride ?? null,
      no_show_override: noShowOverride ?? null,
    });

    return res.data;
  } catch (err) {
    throw new Error(
      err.response?.data?.errors
        ? JSON.stringify(err.response.data.errors)
        : 'Server error'
    );
  }
}